'use client';

import Script from 'next/script';
import { useSyncExternalStore } from 'react';
import { env } from '@/config/env';
import { areAnalyticsCookiesAllowed } from '@/lib/analytics/consent';

const PIXEL_ID = env.NEXT_PUBLIC_META_PIXEL_ID;
const getServerSnapshot = () => false;
const CONSENT_CHECK_INTERVAL_MS = 1000;

function subscribe(onStoreChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {};

  let previousValue = areAnalyticsCookiesAllowed();
  const emitIfChanged = () => {
    const nextValue = areAnalyticsCookiesAllowed();
    if (nextValue === previousValue) return;

    previousValue = nextValue;
    onStoreChange();
  };

  const intervalId = window.setInterval(
    emitIfChanged,
    CONSENT_CHECK_INTERVAL_MS,
  );

  window.addEventListener('focus', emitIfChanged);
  document.addEventListener('visibilitychange', emitIfChanged);

  return () => {
    window.clearInterval(intervalId);
    window.removeEventListener('focus', emitIfChanged);
    document.removeEventListener('visibilitychange', emitIfChanged);
  };
}

export function MetaPixel() {
  const analyticsAllowed = useSyncExternalStore(
    subscribe,
    areAnalyticsCookiesAllowed,
    getServerSnapshot,
  );

  if (!PIXEL_ID || !analyticsAllowed) return null;

  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${PIXEL_ID}');
          fbq('track', 'PageView');
        `,
      }}
      id="meta-pixel"
      strategy="afterInteractive"
    />
  );
}
